module.exports = __webpack_public_path__ + "img/renders-inicio.11b6b8e1.jpg";